// extracted by mini-css-extract-plugin
export default {"header":"CommonQuestions-module__header__xeQVG","item":"CommonQuestions-module__item__SxGIx"};